import { useTranslation } from 'react-i18next';
import { Text, Tooltip } from 'ui';

type P = {
  createdAt: Date;
};

const CommentAge = ({ createdAt }: P) => {
  const { t } = useTranslation();

  return (
    <Tooltip title={t('dateFormats.dateTime', { date: createdAt })}>
      <Text size="small" type="secondary">
        {t('dateFormats.age', { date: createdAt })}
      </Text>
    </Tooltip>
  );
};

export default CommentAge;
